/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".browse-card-meta[_ngcontent-%COMP%]{position:relative;color:#656772;font-size:14px}.browse-card-meta[_ngcontent-%COMP%]   .support-materials[_ngcontent-%COMP%]{position:absolute;font-size:22px;right:0;bottom:-4px}.browse-card-meta[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#656772;text-decoration:none}.browse-card-meta[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#656772}"];
export { styles as styles };
